import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FindWrapper, Inskicksresultat } from 'src/app/pages/inskicks-resultat/inskicks-resultat.models';
import { InskicksResultatService } from 'src/app/pages/inskicks-resultat/inskicks-resultat.service';

enum DataStatus {
  fileMissing,
  analysisMissing,
  full,
}

interface DateStatusObject {
  date: string;
  status: DataStatus;
}
@Component({
    selector: 'app-inskicks-resultat-details',
    templateUrl: './inskicks-resultat-details.component.html',
    styleUrl: './inskicks-resultat-details.component.scss',
    standalone: false
})
export class InskicksResultatDetailsComponent implements OnInit {
  @Input() resultat!: Inskicksresultat;
  protected dataStatus = DataStatus;
  protected dates: DateStatusObject[] = [];
  protected activeIndex!: number;
  protected currentFind?: FindWrapper;
  protected readonly missingResultInfo = 'Analysresultat för detta prov saknas';
  private inskicksresultatService = inject(InskicksResultatService);
  private destroyRef = inject(DestroyRef);
  private finds!: any;
  protected loading = true;

  ngOnInit() {
    this.inskicksresultatService
      .getFindsByProvId(encodeURIComponent(this.resultat.prov_labb_provtagningsar))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: { [date: string]: FindWrapper }) => {
        this.finds = res;
        for (const [key, value] of Object.entries(res)) {
          // sort detail view so positive are on top, then besrkivande, then negative
          const positive = value.finds
            .filter((x) => x.fyndType === 'POSITIVT')
            .sort((a, b) => (a.smittamneName > b.smittamneName ? 1 : -1));
          const beskrivande = value.finds.filter((x) => x.fyndType === 'BESKRIVANDE');
          const negative = value.finds.filter((x) => x.fyndType === 'NEGATIVT');
          const nullType = value.finds.filter((x) => x.fyndType === null);
          const sorted = [...positive, ...beskrivande, ...negative, ...nullType];

          sorted.forEach((find) => find.antimicroList.sort((a, b) => (a.name > b.name ? 1 : -1)));
          value.finds = sorted;
          this.dates.push({
            date: key,
            status: value.fileMissing
              ? DataStatus.fileMissing
              : value.analysisMissing
                ? DataStatus.analysisMissing
                : DataStatus.full,
          });
        }
        this.dates = [...this.dates];

        const lastIndexWithFinds = Object.values(res)
          .reverse()
          .findIndex((x) => !x.fileMissing && !x.analysisMissing);

        this.activeIndex =
          lastIndexWithFinds == 0
            ? Object.values(res).length - 1
            : lastIndexWithFinds
              ? Object.values(res).length - lastIndexWithFinds - 1
              : -1;
        let lastDate = Object.keys(res)[this.activeIndex];

        this.currentFind = res[lastDate];
        this.loading = false;
      });
  }

  private getResultByDate(date: string) {
    const key = Object.keys(this.finds).find((x: string) => x.includes(date)) as string;
    return this.finds[key];
  }

  protected getDate(date: DateStatusObject) {
    if (date.status !== DataStatus.full) {
      this.currentFind = undefined;
    } else {
      const result = this.getResultByDate(date.date);
      if (result) {
        this.currentFind = result;
      }
    }
    this.activeIndex = this.dates.indexOf(date);
  }
}
